import { useParams } from '@tanstack/react-router';

import { CardContainer } from '@/_containers';
import { dateTime } from '@/_shared';

import { TicketDetailsRightSectionLoading } from './loading';

import { useGetSupportTicketDetail } from '../../../shared/apis';
import { PropertiesSection } from '../sections/properties';
import { TicketInformationSection } from '../sections/ticket-information';

export function TicketDetailsRightSection() {
  const { ticket_id: ticketId } = useParams({ strict: false });
  const { isSuccess, data: ticket } = useGetSupportTicketDetail(ticketId || '');

  const formatDueDate = (dateStr: string) => {
    const date = new Date(dateStr);
    const isOverdue = dateTime.isPast(date);
    const formatted = dateTime.format(date);
    return { formatted, isOverdue };
  };

  if (!isSuccess) {
    return <TicketDetailsRightSectionLoading />;
  }

  return (
    <>
      <CardContainer right>
        <TicketInformationSection ticket={ticket} formatDueDate={formatDueDate} />
        <section className="mt-6">
          <PropertiesSection ticket={ticket} />
        </section>
      </CardContainer>
    </>
  );
}
